<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h4><i class="fas fa-history"></i> Histórico de {{ title }}</h4>
                <div>
                    <button
                        class="btn active btn-outline-secondary btn-sm"
                        :title="`Voltar para aba de ${title}`"
                        @click="$emit('voltar')"
                    >
                        <i class="mdi mdi-arrow-left"></i>Voltar
                    </button>
                </div>
            </div>
        </div>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div class="col-md-6 mb-3" v-for="item in itens" :key="item.id">
            <div class="card border" v-if="item.data">
                <div class="card-header bg-gray">
                    <p><b>Data</b> {{ item.data }}</p>
                    <p><b>Técnico</b> {{ item.tecnico }}</p>
                </div>
                <div class="card-body">
                    <p>
                        <b>Status </b>
                        {{
                            verificarResposta(
                                item.status,
                                $root.arrays.status_situacao_rua
                            )
                        }}
                    </p>
                    <p><b>Cidade de origem </b> {{ item.cidade_origem }}</p>
                    <p>
                        <b>Estado de origem </b>
                        {{
                            verificarResposta(
                                item.estado_origem,
                                $root.arrays.estados
                            )
                        }}
                    </p>

                    <p><b>Onde costuma dormir?</b></p>
                    <ul>
                        <li>
                            <b>Rua</b> {{ pergunta(item.ind_dormir_rua_memb) }}
                        </li>
                        <li>
                            <b>Albergue</b>
                            {{ pergunta(item.ind_dormir_albergue_memb) }}
                        </li>
                        <li>
                            <b>Domicílio particular</b>
                            {{ pergunta(item.ind_dormir_dom_part_memb) }}
                        </li>
                        <li>
                            <b>Outro</b> {{ pergunta(item.ind_outro_memb) }}
                        </li>
                    </ul>
                    <p><b>Quantas vezes por semana? </b></p>
                    <ul>
                        <li><b>Rua</b> {{ item.qtd_dormir_freq_rua_memb }}</li>
                        <li>
                            <b>Albergue</b>
                            {{ item.qtd_dormir_freq_albergue_memb }}
                        </li>
                        <li>
                            <b>Domicílio particular</b>
                            {{ item.qtd_dormir_freq_dom_part_memb }}
                        </li>
                        <li><b>Outro</b> {{ item.qtd_freq_outro_memb }}</li>
                    </ul>

                    <p>
                        <b>Há quanto tempo vive na rua?</b>
                        {{ verificarTempo(item.cod_tempo_rua_memb) }}
                    </p>
                    <p>
                        <b
                            >Quais os principais motivos pelos quais passou a
                            morar na rua/albergue/outro?:</b
                        >
                    </p>
                    <ul>
                        <li>
                            <b>Perda de moradia</b>
                            {{ pergunta(item.ind_motivo_perda_memb) }}
                        </li>
                        <li>
                            <b>Ameaça/violência</b>
                            {{ pergunta(item.ind_motivo_ameaca_memb) }}
                        </li>
                        <li>
                            <b>Problemas com familiares/companheiro(a)</b>
                            {{ pergunta(item.ind_motivo_probs_fam_memb) }}
                        </li>
                        <li>
                            <b>Alcoolismo/drogas</b>
                            {{ pergunta(item.ind_motivo_alcool_memb) }}
                        </li>
                        <li>
                            <b>Desemprego</b>
                            {{ pergunta(item.ind_motivo_desemprego_memb) }}
                        </li>
                        <li>
                            <b>Trabalho</b>
                            {{ pergunta(item.ind_motivo_trabalho_memb) }}
                        </li>
                        <li>
                            <b>Tratamento de saúde</b>
                            {{ pergunta(item.ind_motivo_saude_memb) }}
                        </li>
                        <li>
                            <b>Preferência/opção própria</b>
                            {{ pergunta(item.ind_motivo_pref_memb) }}
                        </li>
                        <li>
                            <b>Outro</b>
                            {{ pergunta(item.ind_motivo_outro_memb) }}
                        </li>
                        <li>
                            <b>Não sabe/não lembra</b>
                            {{ pergunta(item.ind_motivo_nao_sabe_memb) }}
                        </li>
                        <li>
                            <b>Não respondeu</b>
                            {{ pergunta(item.ind_motivo_nao_resp_memb) }}
                        </li>
                    </ul>
                    <p>
                        <b>Há quanto tempo mora nesta cidade?</b>
                        {{ verificarTempo(item.cod_tempo_cidade_memb) }}
                    </p>
                    <p>
                        <b>Vive com sua família na rua?</b>
                        {{ pergunta(item.cod_vive_fam_rua_memb) }}
                    </p>
                    <p>
                        <b>Tem contato com parente que viva fora da rua?</b>
                        {{
                            verificarResposta(
                                item.cod_contato_parente_memb,
                                $root.arrays.cod_tempo_contato
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Nos últimos seis meses (nome) frequentou ou
                            participou de alguma atividade comunitária?:</b
                        >
                    </p>
                    <ul>
                        <li>
                            <b>Escola</b>
                            {{ pergunta(item.ind_ativ_com_escola_memb) }}
                        </li>
                        <li>
                            <b>Associação</b>
                            {{ pergunta(item.ind_ativ_com_associação_memb) }}
                        </li>
                        <li>
                            <b>Cooperativa</b>
                            {{ pergunta(item.ind_ativ_com_coop_memb) }}
                        </li>
                        <li>
                            <b>Movimento social</b>
                            {{ pergunta(item.ind_ativ_com_mov_soc_memb) }}
                        </li>
                        <li>
                            <b>Não sabe/não lembra</b>
                            {{ pergunta(item.ind_ativ_com_nao_sabe_memb) }}
                        </li>
                        <li>
                            <b>Não respondeu</b>
                            {{ pergunta(item.ind_ativ_com_nao_resp_memb) }}
                        </li>
                    </ul>
                    <p>
                        <b
                            >Nos últimos seis meses foi atendido em algum dos
                            lugares listados abaixo?:</b
                        >
                    </p>
                    <ul>
                        <li>
                            <b
                                >Centro de Referência da Assistência Social -
                                CRAS</b
                            >
                            {{ pergunta(item.ind_atend_cras_memb) }}
                        </li>
                        <li>
                            <b
                                >Centro de Referência Especializado da
                                Assistência Social - CREAS</b
                            >
                            {{ pergunta(item.ind_atend_creas_memb) }}
                        </li>
                        <li>
                            <b
                                >Centro de referência para população em situação
                                de rua</b
                            >
                            {{ pergunta(item.ind_atend_centro_ref_rua_memb) }}
                        </li>
                        <li>
                            <b
                                >Instituição de acolhimento governamental
                                (albergue/abrigo/outro)</b
                            >
                            {{ pergunta(item.ind_atend_inst_gov_memb) }}
                        </li>
                        <li>
                            <b
                                >Instituição de acolhimento não-governamental
                                (instituição beneficente privada/outro):</b
                            >
                            {{ pergunta(item.ind_atend_inst_nao_gov_memb) }}
                        </li>
                        <li>
                            <b>Hospital/clínica geral</b>
                            {{ pergunta(item.ind_atend_hospital_geral_memb) }}
                        </li>
                        <li>
                            <b>Nenhum</b>
                            {{ pergunta(item.ind_atend_nenhum_memb) }}
                        </li>
                    </ul>
                    <p><b>O que faz para ganhar dinheiro?</b></p>
                    <ul>
                        <li>
                            <b>Construção civil</b>
                            {{ pergunta(item.ind_dinh_const_memb) }}
                        </li>
                        <li>
                            <b>Guardador de carro/flanelinha</b>
                            {{ pergunta(item.ind_dinh_flanelhinha_memb) }}
                        </li>
                        <li>
                            <b>Carregador/estivador</b>
                            {{ pergunta(item.ind_dinh_carregador_memb) }}
                        </li>
                        <li>
                            <b>Catador de material reciclável</b>
                            {{ pergunta(item.ind_dinh_catador_memb) }}
                        </li>
                        <li>
                            <b>Serviços gerais/limpeza /outro</b>
                            {{ pergunta(item.ind_dinh_servs_gerais_memb) }}
                        </li>
                        <li>
                            <b>Pede dinheiro</b>
                            {{ pergunta(item.ind_dinh_pede_memb) }}
                        </li>
                        <li>
                            <b>Vendas</b>
                            {{ pergunta(item.ind_dinh_vendas_memb) }}
                        </li>
                        <li>
                            <b>Outro</b>
                            {{ pergunta(item.ind_dinh_outro_memb) }}
                        </li>
                        <li>
                            <b>Não respondeu</b>
                            {{ pergunta(item.ind_dinh_nao_resp_memb) }}
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else>
                <div v-if="itens.length <= 1">
                    <h4 class="text-secondary">
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        Não possui histórico ainda.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Historico",
    props: ["id", "tipo", "title"],
    data() {
        return {
            loading: true,
            itens: {},
        };
    },
    mounted() {
        this.getItens();
    },
    methods: {
        getItens() {
            axios
                .get(`api/dashboard/usuarios/historico/${this.tipo}/${this.id}`)
                .then((response) => {
                    this.itens = response.data;
                    this.loading = false;
                });
        },
        dateConverter(date) {
            if (date) {
                return moment(date).format("DD/MM/YYYY");
            } else {
                return "";
            }
        },
        verificarTempo(value) {
            var array = [
                "Até seis meses",
                "Entre seis meses e um ano",
                "Entre um e dois anos",
                "Entre dois e cinco anos",
                "Entre cinco e dez anos",
                "Mais de dez anos",
            ];
            return array[value];
        },
        pergunta(item) {
            var value = item == 1 ? 0 : 1;
            return this.$root.arrays.pergunta[value].value;
        },
        verificarResposta(resposta, array) {
            const result = array.filter((item) => item.id == resposta);
            return result[0] ? result[0].value : "";
        },
    },
};
</script>
